export const getNameForFirstLevelQuestion = index => {
  return "answers[".concat(index, "]");
};
export const getNameForSubQuestion = (parentName, index) => {
  return "".concat(parentName, ".subQuestion[").concat(index, "]");
};
export const getNameForSubListQuestion = (parentName, index, code) => {
  return "".concat(parentName, ".listAnswers[").concat(index, "]._").concat(code);
};